import { Button } from '@progress/kendo-react-buttons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Loader } from '@progress/kendo-react-indicators';
import { Input, NumericTextBox } from '@progress/kendo-react-inputs';
import { Label } from '@progress/kendo-react-labels';
import { JsonResponse } from 'TypeGen/json-response';
import { useState } from 'react';
import CenterDivPanel from '../../components/CenterDivPanel';
import { fetchApi } from '../../services/api';
import { isNullOrWhiteSpace, isValidEmail } from '../../utils/utils';

type Props = {
  customerId: number;
  customerNumber: string;
  customerName: string;
  creditLimit: number;
  invoiceEmailAddress: string;
  onClose: () => void;
};

const SendWelcomePacket = (props: Props) => {
  const [customerNumber,] = useState(props.customerNumber);
  const [customerName, setCustomerName] = useState(props.customerName);
  const [creditLimit, setCreditLimit] = useState<number>(props.creditLimit);
  const [paymentTerms, setPaymentTerms] = useState('NET30');
  const [invoiceDeliveryMethod, setInvoiceDeliveryMethod] = useState('Email');
  const [invoiceEmailAddress, setInvoiceEmailAddress] = useState(props.invoiceEmailAddress);
  const [emailPacketTo, setEmailPacketTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<Partial<JsonResponse>>({ Success: false });

  const submit = () => {
    setLoading(true);
    fetchApi('/api/Customer/SendWelcomePacket', {
      customerID: props.customerId,
      customerNumber,
      customerName,
      creditLimit,
      paymentTerms,
      invoiceDeliveryMethod,
      invoiceEmailAddress,
      emailPacketTo
    }, 'POST')
      .then((data: JsonResponse) => setResult(data))
      .finally(() => setLoading(false));
  };

  return (
    <Dialog title="Send Welcome Packet" onClose={props.onClose} width={450}>
      {loading && <CenterDivPanel><Loader type="converging-spinner" /></CenterDivPanel>}
      <div className="k-form k-form-md p-0">
        {result && !loading && result.Success && <div className="mt-3 alert alert-success">Welcome packet sent!</div>}
        {result && !loading && result.Success === false && result.ErrorMessage && <div className="mt-3 alert alert-danger">{result.ErrorMessage}</div>}
        <FieldWrapper>
          <Label>Customer Name</Label>
          <Input required value={customerName} onChange={e => setCustomerName(e.value)} />
        </FieldWrapper>
        <FieldWrapper>
          <Label>Credit Limit</Label>
          <NumericTextBox required value={creditLimit} onChange={e => setCreditLimit(e.value)} />
        </FieldWrapper>
        <FieldWrapper>
          <Label>Payment Terms</Label>
          <Input required value={paymentTerms} onChange={e => setPaymentTerms(e.value)} />
        </FieldWrapper>
        <FieldWrapper>
          <Label>Invoice Delivery Method</Label>
          <Input required value={invoiceDeliveryMethod} onChange={e => setInvoiceDeliveryMethod(e.value)} />
        </FieldWrapper>
        <FieldWrapper>
          <Label>Invoice Email Address (Applicable if delivery method is Email)</Label>
          <Input required value={invoiceEmailAddress} onChange={e => setInvoiceEmailAddress(e.value)} />
        </FieldWrapper>
        <hr />
        <FieldWrapper>
          <Label>Email Packet To</Label>
          <Input type="email" required value={emailPacketTo} valid={isValidEmail(emailPacketTo)} onChange={e => setEmailPacketTo(e.value)} />
        </FieldWrapper>
      </div>
      <DialogActionsBar>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button themeColor="primary" disabled={loading || isNullOrWhiteSpace(customerNumber) || isNullOrWhiteSpace(customerName) || isNullOrWhiteSpace(invoiceEmailAddress)
          || creditLimit <= 0 || isNullOrWhiteSpace(paymentTerms) || isNullOrWhiteSpace(invoiceDeliveryMethod) || !isValidEmail(emailPacketTo) || result.Success} onClick={submit}>Send</Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default SendWelcomePacket;